import { render, staticRenderFns } from "./ListEmpty.vue?vue&type=template&id=4070058a"
import script from "./ListEmpty.vue?vue&type=script&lang=js"
export * from "./ListEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports